import { LabelsMap } from 'new/form/common/types';

import { businessDetailsSectionLabelsMap } from './sections/businessDetails/labels';
import { factoringNeedSectionLabelsMap } from './sections/factoringNeed/labels';

export const financingNeedPageLabelsMap: LabelsMap = {
  ...businessDetailsSectionLabelsMap,
  ...factoringNeedSectionLabelsMap,
};
